import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { generateCompleteAddress, roundToTwo } from "../../function/other";
import { MainContext } from "../../utils/private_routes/PrivateRoutes";
import { ToWords } from "to-words";

type PropType = {
  apiData: any;
  generalSetting: any;
  width?: string;
  boxShadow?: string;
};

const GenerateInvoiceDoc: React.FC<PropType> = (props) => {
  const toWords = new ToWords();

  const { apiData, generalSetting, width, boxShadow } = props;
  const companyObj = JSON.parse(window.localStorage.getItem("company") || "");

  const { setting, documentSetting } = useContext(MainContext);

  const taxesWithPercent: any = [];

  const [finalTaxesWithPercent, setFinalTaxesWithPercent] = useState([]);

  const checkItemTax = new Set();

  const fn = {
    calculate: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      if (apiData?.placeOfSupply === companyObj?.state) {
        obj.cgst = roundToTwo(totalTax / 2);
        obj.sgst = roundToTwo(totalTax / 2);
        obj.igst = 0;
        obj.taxinsideState = item?.tax / 2;
      } else {
        obj.cgst = 0;
        obj.sgst = 0;
        obj.igst = roundToTwo(totalTax);
        obj.taxOutsideState = item?.tax;
      }

      return obj;
    },

    calculateIgst: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      obj.igst = roundToTwo(totalTax);

      return obj.igst;
    },

    calculateSgst: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      obj.sgst = roundToTwo(totalTax / 2);

      return obj.sgst;
    },

    calculateCgst: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      obj.cgst = roundToTwo(totalTax / 2);

      return obj.cgst;
    },

    calculateTotal: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
        total: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      if (apiData?.placeOfSupply === companyObj?.state) {
        obj.cgst = roundToTwo(totalTax / 2);
        obj.sgst = roundToTwo(totalTax / 2);
        obj.igst = 0;
        obj.taxinsideState = item?.tax / 2;
        obj.total = obj.cgst + obj.sgst;
      } else {
        obj.cgst = 0;
        obj.sgst = 0;
        obj.igst = roundToTwo(totalTax);
        obj.taxOutsideState = item?.tax;
        obj.total = obj.igst;
      }

      return obj.total;
    },

    calculateTaxes: () => {
      apiData?.items?.forEach((element: any) => {
        if (checkItemTax.has(element.tax)) {
          taxesWithPercent.forEach((taxElement: any) => {
            if (element.tax === taxElement.tax) {
              taxElement.taxableValue =
                element.unitQtyPrice * element.qty -
                roundToTwo(fn.calculate(element).discount);
              taxElement.cgst = taxElement.cgst + fn.calculateCgst(element);
              taxElement.sgst = taxElement.sgst + fn.calculateSgst(element);
              taxElement.igst = taxElement.igst + fn.calculateIgst(element);
              taxElement.total = taxElement.total + fn.calculateTotal(element);
            }
          });
        } else {
          checkItemTax.add(element.tax);
          taxesWithPercent.push({
            taxableValue:
              element.unitQtyPrice * element.qty -
              roundToTwo(fn.calculate(element).discount),
            tax: element.tax,
            cgst: fn.calculateCgst(element),
            sgst: fn.calculateSgst(element),
            igst: fn.calculateIgst(element),
            total: fn.calculateTotal(element),
          });
        }
      });

      setFinalTaxesWithPercent(taxesWithPercent);
    },
  };

  useEffect(() => {
    if (apiData?.items?.length > 0) {
      fn.calculateTaxes();
    }
  }, [apiData]);

  return (
    <>
      <div
        id="content"
        style={{ width: width, margin: "auto", boxShadow: boxShadow }}
        className="doc_wrapper py-3 px-4"
      >
        <div className="text-end font16x600 textColor3">Original Copy</div>
        <div className="container-fluid p-0 mt-3">
          <div className="row">
            <div className="col-6">
              <h3 className="font20x600 textColor3">{companyObj?.name}</h3>
              <div className="mt-4">
                <p className="mb-0 font12x500 textColor3">
                  {generateCompleteAddress(
                    companyObj?.address,
                    companyObj?.city,
                    companyObj?.state,
                    companyObj?.country,
                    companyObj?.pincode
                  )
                    .filter((item) => item?.length)
                    .join(", ")}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {`${companyObj?.phoneCode} ${companyObj?.phoneNumber}`}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {companyObj?.emailAddress}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  Contact Name: <span>{companyObj?.contactName}</span>
                </p>
                <p className="mb-0 font12x500 textColor3">
                  GSTIN: <span>--</span>
                </p>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex justify-content-between align-items-center">
                <p className="mb-0 font16x600 textColor3">Invoice</p>
                <p className="mb-0 font20x600 textColor3">
                  {apiData?.invoiceNumber}
                </p>
              </div>
              <div className="mt-3">
                {documentSetting?.invoice?.tAD ? (
                  <div
                    className="d-flex justify-content-between align-items-center px-3"
                    style={{
                      backgroundColor: "var(--bg_color2)",
                    }}
                  >
                    <p className="mb-0 text-white font16x500">Amount Due:</p>
                    <p className="mb-0 text-white font16x500">
                      {`₹ ${apiData?.dueAmount}`}
                    </p>
                  </div>
                ) : (
                  ""
                )}
                <div
                  className="mt-3"
                  style={{
                    width: "50%",
                    margin: "0 0 0 auto",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">Issue Date:</span>
                    <span className="font12x400 textColor3">
                      {moment(apiData?.invoiceDate).format(setting?.dateFormat)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">Due Date:</span>
                    <span className="font12x400 textColor3">
                      {moment(apiData?.dueDate).format(setting?.dateFormat)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">
                      Place of supply:
                    </span>
                    <span className="font12x400 textColor3">
                      {apiData?.placeOfSupply}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-3 col-6">
              <h3 className="font14x600 textColor3">Bill to</h3>
              <div>
                <p className="mb-0 font12x500 textColor3">
                  {apiData?.client?.name}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {apiData?.client?.contactNumber}
                  {/* {`${apiData?.client?.phoneCode} ${apiData?.client?.contactNumber}`} */}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {generateCompleteAddress(
                    apiData?.client?.completeAddress?.address,
                    apiData?.client?.completeAddress?.city,
                    apiData?.client?.completeAddress?.state,
                    apiData?.client?.completeAddress?.country,
                    apiData?.client?.completeAddress?.pincode
                  )
                    .filter((item) => item?.length)
                    .join(", ")}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {apiData?.client?.email}
                </p>
                {!(
                  apiData?.client?.gstType === "Unregistered Business" ||
                  apiData?.client?.gstType === "Consumer (B2C)" ||
                  apiData?.client?.gstType === "Overseas (Outside India)"
                ) &&
                  apiData?.client?.gstin !== "" && (
                    <p className="mb-0 font12x500 textColor3">
                      GSTIN:{" "}
                      <span className="font12x400">
                        {apiData?.client?.gstin}
                      </span>
                    </p>
                  )}
                {apiData?.client?.pan !== "" && (
                  <p className="mb-0 font12x500 textColor3">
                    PAN:{" "}
                    <span className="font12x400">{apiData?.client?.pan}</span>
                  </p>
                )}

                {documentSetting?.invoice?.cPBTS &&
                apiData?.lead?.contactPerson ? (
                  <p className="mb-0 font12x500 textColor3">
                    Contact Person:{" "}
                    <span className="font12x400">
                      {apiData?.lead?.contactPerson}
                    </span>
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            {documentSetting?.invoice?.sA ? (
              <div className="mt-3 col-6">
                <h3 className="font14x600 textColor3">Ship to</h3>
                <div>
                  <p className="mb-0 font12x500 textColor3">
                    {generateCompleteAddress(
                      apiData?.client?.completeAddress?.address,
                      apiData?.client?.completeAddress?.city,
                      apiData?.client?.completeAddress?.state,
                      apiData?.client?.completeAddress?.country,
                      apiData?.client?.completeAddress?.pincode
                    )
                      .filter((item) => item?.length)
                      .join(", ")}
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="mt-3">
              <table className="doc_table">
                <thead
                  style={{
                    backgroundColor: "var(--bg_color2)",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th scope="col">Item & Description</th>
                    <th scope="col">HSN/SAC</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Price (₹)</th>
                    <th scope="col">Discount (₹)</th>
                    <th>Taxable Value (₹)</th>
                    {apiData?.placeOfSupply === companyObj?.state ? (
                      <>
                        <th scope="col">CGST (₹)</th>
                        <th scope="col">SGST (₹)</th>
                      </>
                    ) : (
                      <th scope="col">IGST (₹)</th>
                    )}
                    <th scope="col">Total (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {apiData?.items?.map((item: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          <p className="mb-0 font12x500 textColor2">
                            {item?.name}
                          </p>
                          <p className="mb-0 font10x500 textColor1">
                            {item?.description}
                          </p>
                        </td>
                        <td>{item?.hsnOrsac}</td>
                        <td>{item?.qty}</td>
                        <td>{item?.unitQtyPrice?.toLocaleString()}</td>
                        <td>
                          <p className="mb-0 textColor1">
                            {roundToTwo(fn.calculate(item).discount)}
                          </p>
                          <p className="mb-0 font10x500 textColor1">
                            {`${item?.discount}%`}
                          </p>
                        </td>
                        <td>
                          {(
                            item?.unitQtyPrice * item?.qty -
                            roundToTwo(fn.calculate(item).discount)
                          )?.toLocaleString()}
                        </td>
                        {apiData?.placeOfSupply === companyObj?.state ? (
                          <>
                            <td>
                              <p className="mb-0 textColor1">
                                {roundToTwo(fn.calculate(item).cgst)}
                              </p>
                              <p className="mb-0 font10x500 textColor1">
                                {`${roundToTwo(
                                  fn.calculate(item).taxinsideState
                                )}%`}
                              </p>
                            </td>
                            <td>
                              <p className="mb-0 textColor1">
                                {roundToTwo(fn.calculate(item).sgst)}
                              </p>
                              <p className="mb-0 font10x500 textColor1">
                                {`${roundToTwo(
                                  fn.calculate(item).taxinsideState
                                )}%`}
                              </p>
                            </td>
                          </>
                        ) : (
                          <td>
                            <p className="mb-0 textColor1">
                              {roundToTwo(fn.calculate(item).igst)}
                            </p>
                            <p className="mb-0 font10x500 textColor1">
                              {`${roundToTwo(
                                fn.calculate(item).taxOutsideState
                              )}%`}
                            </p>
                          </td>
                        )}

                        <td>{roundToTwo(item?.total)?.toLocaleString()}</td>
                      </tr>
                    );
                  })}
                </tbody>

                <tbody>
                  {finalTaxesWithPercent?.map((element: any, index: any) => {
                    return (
                      <tr key={index}>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border text-end d-flex justify-content-between">
                          <p className="mb-0 font12x600 textColor1">
                            {index === 0 ? `Total` : ""}
                          </p>
                          <p className="mb-0 font12x600 textColor1 ms-3">
                            @{element.tax}%
                          </p>
                        </td>
                        <td>{element?.taxableValue}</td>
                        {apiData?.placeOfSupply === companyObj?.state ? (
                          <>
                            <td>{element?.cgst}</td>
                            <td>{element?.sgst}</td>
                          </>
                        ) : (
                          <td>{element?.igst}</td>
                        )}

                        <td>{element?.total?.toLocaleString()}</td>
                      </tr>
                    );
                  })}

                  <tr>
                    <td colSpan={10} className="no-top-border">
                      <div
                        className="py-2"
                        style={{ width: "55%", marginLeft: "auto" }}
                      >
                        {apiData?.calculation?.discount != 0 && (
                          <div className="total-section d-grid justify-content-between mb-1">
                            <p className="mb-0 font12x600 textColor3 text-end">
                              Discount
                            </p>
                            <p className="mb-0 font12x600 textColor3 text-end">
                              {`₹ ${apiData?.calculation?.discount?.toLocaleString()}`}
                            </p>
                          </div>
                        )}
                        <div className="total-section d-grid justify-content-between mb-1">
                          <p className="mb-0 font12x600 textColor3 text-end">
                            Total Taxable Value
                          </p>
                          <p className="mb-0 font12x600 textColor3 text-end">
                            {`₹ ${(
                              apiData?.calculation?.subTotal -
                              apiData?.calculation?.discount
                            )?.toLocaleString()}`}
                          </p>
                        </div>
                        <div className="total-section d-grid justify-content-between mb-1">
                          <p className="mb-0 font12x600 textColor3 text-end">
                            Total Value (in figure)
                          </p>
                          <p className="mb-0 font12x600 textColor3 text-end">
                            {`₹ ${apiData?.calculation?.total?.toLocaleString()}`}
                          </p>
                        </div>
                        {documentSetting?.invoice?.tIW ? (
                          <div className="total-section d-grid justify-content-between mb-1">
                            <p className="mb-0 font12x600 textColor3 text-end">
                              Total Value (in words)
                            </p>
                            {apiData &&
                            apiData.calculation &&
                            apiData.calculation.total ? (
                              <p className="mb-0 font12x600 textColor3 text-end">
                                {toWords.convert(apiData?.calculation?.total, {
                                  // ignoreDecimal: true,
                                  currency: true,
                                })}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {documentSetting?.invoice?.nRTS ? (
                          <div className="total-section d-grid justify-content-between mb-1">
                            <p className="mb-0 font12x600 textColor3 text-end">
                              Net Received
                            </p>
                            <p className="mb-0 font12x600 textColor3 text-end">
                              ₹{" "}
                              {(
                                apiData.calculation?.total - apiData?.dueAmount
                              )?.toLocaleString()}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="d-flex justify-content-end gap-2">
                {documentSetting?.invoice?.pS &&
                  generalSetting?.primarySignature && (
                    <div>
                      <div className="pt-4 signature-text-container">
                        <div className="signature-container">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}${generalSetting?.primarySignature}`}
                            width={100}
                          />
                        </div>
                        <p className="mt-2 mb-0 font10x500 text-start">
                          {generalSetting?.pSName}
                        </p>
                      </div>
                    </div>
                  )}

                {documentSetting?.invoice?.sS &&
                  generalSetting?.secondarySignature && (
                    <div>
                      <div className="pt-4 signature-text-container">
                        <div className="signature-container">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}${generalSetting?.secondarySignature}`}
                            width={100}
                          />
                        </div>
                        <p className="mt-2 mb-0 font10x500 text-start">
                          {generalSetting?.sSName}
                        </p>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateInvoiceDoc;
